import PairingManage from '../container/detail/PairingManage';

function PairingManagePage() {
  return <PairingManage />;
}

export default PairingManagePage;
